const CompanyEnum = {
  Quotations: {
    id: 1,
    name: "Captain's Log",
  },
  ProductsAndServices: {
    id: 2,
    name: "Tuuki Electric",
  },
  LeadNotes: {
    id: 3,
    name: "LesGendair",
  },
};

export default CompanyEnum;
